import { useCallback, useContext, useEffect } from "react";
import { ToolTipContext } from "./Context";

export const useTooltip = (elmRef, content, disabled = false) => {
  const context = useContext(ToolTipContext);

  const handleMouseEnter = useCallback(() => {
    if (!disabled) context.activate(elmRef.current.getAttribute("id"));
  }, [context, disabled, elmRef]);

  const handleMouseLeave = useCallback(() => {
    context.deactivate();
  }, [context]);

  useEffect(() => {
    const success = context.registerTooltip(elmRef, content);
    const elm = elmRef.current;

    if (success) {
      elm.addEventListener("mouseenter", handleMouseEnter);
      elm.addEventListener("mouseleave", handleMouseLeave);

      return () => {
        elm.removeEventListener("mouseenter", handleMouseEnter);
        elm.removeEventListener("mouseleave", handleMouseLeave);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);
};
